import map from 'lodash/map';
import isEqual from 'lodash/isEqual';
import toInteger from 'lodash/toInteger';
import { combineReducers } from 'redux';
import { APP_HISTORY_CHANGE } from '../App/app.actions';
import { STORIES_SEARCH_CHANGE } from '../Stories/stories.actions';
import {
    PROFILES_SEARCH_CHANGE,
    PROFILES_PAGE_CHANGE,

    PROFILES_TYPES_FETCH_REQUEST,
    PROFILES_TYPES_FETCH_SUCCESS,
    PROFILES_TYPES_FETCH_FAILURE,

    PROFILES_FETCH_REQUEST,
    PROFILES_FETCH_SUCCESS,
    PROFILES_FETCH_FAILURE,
} from './profiles.actions';

/**
 * Profiles search reducer
 */
function search(
    state = {
        query: '',
        profilesType: '',
    },
    action,
) {
    switch (action.type) {
    /**
     * Applying search if it's changed
     */
    case PROFILES_SEARCH_CHANGE:
        return Object.assign({}, state, action.search);
    /**
     * Applying url query string
     */
    case APP_HISTORY_CHANGE: {
        const {
            query = '',
            profiles_type = '', // eslint-disable-line camelcase
        } = action.payload;
        const result = {
            query,
            profilesType: profiles_type,
        };
        return isEqual(state, result) ? state : result;
    }
    /**
     * Applying changed search query from stories to profiles
     */
    case STORIES_SEARCH_CHANGE: {
        const query = action.search.query;
        return query === state.query
            ? state
            : Object.assign({}, state, { query });
    }
    /**
     * Returning current state if reducer doesn't wait for this action
     */
    default:
        return state;
    }
}

/**
 * Profiles types reducer
 */
function profilesTypes(
    state = {
        fetching: false,
        fetchFailed: false,
        items: [],
        itemsNum: 0,
    },
    action,
) {
    switch (action.type) {
    /**
     * Handling of started profiles types fetching
     */
    case PROFILES_TYPES_FETCH_REQUEST:
        return Object.assign({}, state, {
            fetching: true,
            fetchFailed: false,
        });
    /**
     * Handling of successful fetching
     */
    case PROFILES_TYPES_FETCH_SUCCESS:
        return Object.assign({}, state, {
            fetching: false,
            fetchFailed: false,
            items: map(action.payload.info.page.facets.profiles_type, (value, key) => ({
                key,
                quantity: value,
            })),
            itemsNum: action.payload.info.page.total_result_count,
        });
    /**
     * Handling of failed fetching
     */
    case PROFILES_TYPES_FETCH_FAILURE:
        return Object.assign({}, state, {
            fetching: false,
            fetchFailed: true,
        });
    /**
     * Returning current state if reducer doesn't wait for this action
     */
    default:
        return state;
    }
}

/**
 * Profiles reducer
 */
function profiles(
    state = {
        fetching: false,
        fetchFailed: false,
        page: 1,
        pagesNum: 0,
        items: [],
        itemsNum: 0,
    },
    action,
) {
    switch (action.type) {
    /**
     * Applying search change
     */
    case PROFILES_SEARCH_CHANGE:
        return Object.assign({}, state, {
            page: 1,
            pagesNum: 0,
        });
    /**
     * Applying page change
     */
    case PROFILES_PAGE_CHANGE:
        return Object.assign({}, state, {
            page: action.page,
        });
    /**
     * Handling of started profiles fetching
     */
    case PROFILES_FETCH_REQUEST:
        return Object.assign({}, state, {
            fetching: true,
            fetchFailed: false,
        });
    /**
     * Handling of successful fetching
     */
    case PROFILES_FETCH_SUCCESS:
        return Object.assign({}, state, {
            fetching: false,
            fetchFailed: false,
            page: action.payload.info.page.current_page,
            pagesNum: action.payload.info.page.num_pages,
            items: action.payload.records.page,
            itemsNum: action.payload.info.page.total_result_count,
        });
    /**
     * Handling of failed fetching
     */
    case PROFILES_FETCH_FAILURE:
        return Object.assign({}, state, {
            fetching: false,
            fetchFailed: true,
        });
    /**
     * Applying url query string
     */
    case APP_HISTORY_CHANGE: {
        const page = toInteger(action.payload.page) || 1;
        return state.page === page
                ? state
                : Object.assign({}, state, { page });
    }
    /**
     * Returning current state if reducer doesn't wait for this action
     */
    default:
        return state;
    }
}

/**
 * The main profiles reducer
 */
export default combineReducers({
    search,
    profilesTypes,
    profiles,
});



// WEBPACK FOOTER //
// ./src/js/Profiles/profiles.reducer.js